import { render, staticRenderFns } from "./ModalOrderHistory.vue?vue&type=template&id=3008c9c0"
import script from "./ModalOrderHistory.vue?vue&type=script&lang=js"
export * from "./ModalOrderHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports